import React from 'react';
import Seo from '../components/Seo';
import { companyProfile } from '../content/siteContent';
import { domains } from '../content/domainConfig';

const homeTiles = [
  {
    id: 'training',
    label: 'IT Training & Job',
    imageSrc: '/training-section.webp',
    imageAlt: 'IT Training and Job Placement by Vedanskrix',
    href: domains.itTraining,
    newTab: false,
    area: 'training',
  },
  {
    id: 'technology',
    label: 'Technology',
    imageSrc: '/VedanskrixTechnology.webp',
    imageAlt: 'Technology services by Vedanskrix',
    href: domains.technology,
    newTab: true,          // opens technology.vedanskrix.com in new tab
    area: 'technology',
  },
  {
    id: 'career',
    label: 'Career Development',
    imageSrc: '/career-development-section.webp',
    imageAlt: 'Career development support by Vedanskrix',
    href: domains.career,
    newTab: false,
    area: 'career',
  },
  {
    id: 'admission',
    label: 'College Admission',
    imageSrc: '/admission-guidance.webp',
    imageAlt: 'College admission guidance by Vedanskrix',
    href: domains.admission,
    newTab: false,
    area: 'admission',
  },
  {
    id: 'global',
    label: 'Global Opportunities',
    imageSrc: '/global-opportunities-section.webp',
    imageAlt: 'Global opportunities and visa services by Vedanskrix',
    href: domains.global,
    newTab: false,
    area: 'global',
  },
];

function Home() {
  return (
    <div className="page-home page-home-v2">
      <Seo
        title="Vedanskrix | Technology · Training · Career · Admission · Global"
        description="Vedanskrix offers IT training, technology services, career development, college admission guidance, and global visa support in Ahmedabad."
        keywords={[
          'IT training Ahmedabad',
          'technology services Ahmedabad',
          'career development Ahmedabad',
          'college admission guidance Ahmedabad',
          'visa services Ahmedabad',
          'Vedanskrix Web LLP',
        ]}
        schema={{
          '@context': 'https://schema.org',
          '@type': 'WebSite',
          name: companyProfile.brandName,
          url: companyProfile.websiteUrl,
          description:
            'Technology, training, career, admission, and global opportunity services by Vedanskrix.',
        }}
      />

      <section className="home-tile-section home-tile-section--fullscreen" aria-label="Service categories">
        <div className="home-tile-grid">
          {homeTiles.map((tile) => (
            <a
              key={tile.id}
              href={tile.href}
              target={tile.newTab ? '_blank' : '_self'}
              rel={tile.newTab ? 'noopener noreferrer' : undefined}
              className={'htile htile--' + tile.area}
              aria-label={tile.label}
            >
              <img
                src={tile.imageSrc}
                alt={tile.imageAlt}
                className="htile__img"
                loading={tile.id === 'training' ? 'eager' : 'lazy'}
                fetchpriority={tile.id === 'training' ? 'high' : undefined}
              />
              <span className="htile__overlay" />
              <span className="htile__logo-mark" aria-hidden="true">
                <img src="/logo.jpg" alt="Vedanskrix" className="htile__logo-img" />
              </span>
              <span className="htile__label-bar">
                <span className="htile__label">{tile.label}</span>
              </span>
            </a>
          ))}
        </div>
      </section>
    </div>
  );
}

export default Home;
